module.exports = __webpack_public_path__ + "img/3.8e7c7d61.jpg";